<script>
		import { createEventDispatcher } from 'svelte';
		import MdcUtils from './MdcUtils';

const dispatch = createEventDispatcher();
	var email='', password='', registerUser=1, needAccount=false, showPassword=false, prevpwd='';

function toggleNeedAccount() {
	needAccount = !needAccount;
	if(needAccount){
		registerUser = 1;
		prevpwd	= password;
		password = MdcUtils.randomString()
	} else {
		password = prevpwd;
		registerUser = 0;
		showPassword	= false;
	}
}
</script>

<div id="login-register" class="modal" style="margin-top:2.333rem;max-width:433px; width:100%; margin-left:auto; margin-right:auto;">
<div id="login-tray" style="background-color:rgba(255,255,255,0.666);border-radius: 10px;padding:1.333em;box-shadow:0 0 1px black">
	{#if needAccount && !(new URL(window.location.href).hash.startsWith('#app/cash/'))}
<div class="notice">
	<p>Sorry! You can only start a new account if you have some cash to pickup.</p>
	<p style="font-weight:normal">During this research phase, you can have a friend send you some, or contact the founder to get started. Just ask them for a cash pickup URL or QR code.</p>
</div>
	{:else}
		{#if needAccount}
<h2 style="margin-top:0;">New User</h2>
<p>Passwords are generated automatically. They cannot be changed.</p>
{:else}
<h2 style="margin-top:0;">Login</h2>
		{/if}
	<input class="w100" type="text" bind:value={email} placeholder="Email">
	<br>
	<input class="w100" id="pwd" type={showPassword ? 'text' : 'password'}	value={password} placeholder="Password"
	disabled={needAccount ? 'disabled' : ''}
	on:change={e => {password = e.target.value}}
	>
	{#if needAccount}<a href="#" class="clickable" on:click|preventDefault={()=>{showPassword=!showPassword}}>{showPassword?'hide password':'show password'}</a>{/if}
	<br>
	<button class="selectable w100"	on:click={() => { 
		dispatch('action',{do:'doLogin', method: 'post', url: '/api/login', body:{ email, password, registerUser } }) }
		}>Login</button>
		{/if}

		{#if !needAccount}
		<h2>New User</h2>
	<button class="selectable w100"  on:click={toggleNeedAccount}>I need an account</button>
	{:else}
	<h2>Existing User</h2>
		<button class="selectable w100" on:click={toggleNeedAccount}>I already have an account</button>
	{/if}

	</div>


	<p style="margin=top:1rem;"><a href="/" on:click|preventDefault={ ()=> { dispatch('action',{do:'doCloseApp'})}}>Close</a></p>


</div>

<style>
	#login-register {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}
</style>